module.exports = __webpack_public_path__ + "static/be-the-first-18289656be0c5950a7a31ab7eec271ee.jpg";